import { render, staticRenderFns } from "./AppBibleText.vue?vue&type=template&id=88038f04&"
import script from "./AppBibleText.vue?vue&type=script&lang=js&"
export * from "./AppBibleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports